export enum RelationType {
    TICKET_EXPORT = "TICKET_EXPORT",
    ROAD_DEPO_FERRY = "ROAD_DEPO_FERRY",
    FERRY_DEPO_ROAD = "FERRY_DEPO_ROAD",
    RAIL_DEPO_FERRY = "RAIL_DEPO_FERRY",
    FERRY_DEPO_RAIL = "FERRY_DEPO_RAIL",
    RAIL_FERRY = "RAIL_FERRY",
    FERRY_RAIL = "FERRY_RAIL",
    ROAD_DEPO_ROAD = "ROAD_DEPO_ROAD",
    ROAD_DEPO_RAIL = "ROAD_DEPO_RAIL",
    RAIL_DEPO_ROAD = "RAIL_DEPO_ROAD",
    RAIL_DEPO_RAIL = "RAIL_DEPO_RAIL",
    FERRY_DEPO = "FERRY_DEPO",
    RAIL_DEPO = "RAIL_DEPO",
    ROAD_DEPO = "ROAD_DEPO",
    DEFAULT = "DEFAULT"
}
